export interface ISnackbarOptions {
  content:string;
  actionText?:string;
  delay?:number;
}

export interface ISnackbarService {
  show(options:ISnackbarOptions):ng.IPromise<void>;
  hide(options:ISnackbarOptions):ng.IPromise<void>;
}

export default class SnackbarService implements ISnackbarService {
  static $inject = ['$document', '$compile', '$timeout', '$rootScope', '$q',
    '$log'];

  snackbar:HTMLElement;

  constructor(private $document:ng.IDocumentService,
              private $compile:ng.ICompileService,
              private $timeout:ng.ITimeoutService,
              private $rootScope:ng.IRootScopeService,
              private $q:ng.IQService,
              private $log:ng.ILogService) {
  }

  show(options:ISnackbarOptions):ng.IPromise<void> {
    if (this.snackbar) {
      return this.hide().then(() => {
        return this.show(options);
      });
    } else {
      const deferred = this.$q.defer<void>();
      const document = <HTMLDocument><any>this.$document[0];
      this.snackbar = this.buildSnackbar(options);
      this.snackbar.classList.add('enter', 'animation-start');
      this.snackbar.addEventListener('transitionend', () => {
        this.$log.debug('Snackbar is visible.');
        deferred.resolve();
      });
      document.body.appendChild(this.snackbar);
      this.$timeout(() => {
        this.snackbar.classList.remove('animation-start');
        this.snackbar.classList.add('animation-end');
      }, 0);
      this.$timeout(() => {
        this.hide();
      }, options.delay || 2000);
      return deferred.promise;
    }
  }

  hide() {
    const deferred = this.$q.defer<void>();
    if (this.snackbar) {
      this.snackbar.classList.remove('enter', 'animation-end');
      this.snackbar.classList.add('animation-start', 'exit');
      this.$timeout(() => {
        this.snackbar.classList.remove('animation-start');
        this.snackbar.classList.add('animation-end');
      }, 0);
      this.snackbar.addEventListener('transitionend', () => {
        this.$log.debug('Snackbar is hidden.');
        deferred.resolve();
        this.snackbar = null;
      });
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  }

  private buildSnackbar(options:ISnackbarOptions) {
    const document = <HTMLDocument><any>this.$document[0];
    const snackbar = document.createElement('imomo-snackbar');
    const snackbarContent = document.createElement('snackbar-content');
    snackbarContent.textContent = options.content;
    snackbar.appendChild(snackbarContent);
    if (options.actionText) {
      const snackbarActionText = document.createElement('snackbar-action-text');
      snackbarActionText.textContent = options.actionText;
      snackbar.appendChild(snackbarActionText);
    }
    const scope = this.$rootScope.$new(true);
    const compiledSnackbar = this.$compile(snackbar)(scope);
    document.body.appendChild(compiledSnackbar[0]);
    return compiledSnackbar[0];
  }
}



/** WEBPACK FOOTER **
 ** ./app/snackbar/snackbar.service.ts
 **/